import { useEffect, useState } from "react";
import { DateBox } from "./DateBox";
import { quarterHourOptions, timeLabel } from "./time-options";
import { SelectField } from "./ui";

/**
 * Date typed as dd/mm/aaaa plus a time picked from a list, as a local "YYYY-MM-DDTHH:MM" value.
 * Replaces datetime-local, which Safari shows prefilled while it is actually empty.
 */
export function DateTimeBox({ label, name, value, min, className = "", onChange }: {
  label: string;
  name: string;
  value: string;
  min?: string;
  className?: string;
  onChange: (value: string) => void;
}) {
  const [date, setDate] = useState(value.slice(0, 10));
  const [time, setTime] = useState(value.slice(11, 16) || "09:00");
  useEffect(() => {
    if (value) {
      setDate(value.slice(0, 10));
      setTime(value.slice(11, 16) || "09:00");
    }
  }, [value]);
  const emit = (nextDate: string, nextTime: string) => onChange(/^\d{4}-\d{2}-\d{2}$/.test(nextDate) ? `${nextDate}T${nextTime}` : "");
  return (
    <div className={`date-time-box ${className}`}>
      <DateBox label={label} name={name} value={date} {...(min ? { min } : {})} onChange={(next) => { setDate(next); emit(next, time); }} />
      <SelectField label={`Hora · ${label}`} value={time} onChange={(e) => { setTime(e.target.value); emit(date, e.target.value); }}>
        {quarterHourOptions(time).map((option) => <option key={option} value={option}>{timeLabel(option)}</option>)}
      </SelectField>
    </div>
  );
}
